<template>
  <div>
    <CloseButton mode="details" @click="toggleMatch" />
    <p>No Match</p>
    <p>Não encontrado</p>
    <slot></slot>
    <span>😭</span>
  </div>
</template>
<script setup>
import CloseButton from "../buttons/CloseButton.vue";

import { defineEmits } from "vue";

const emit = defineEmits(["toggle-match"]);

function toggleMatch() {
  emit("toggle-match");
}
</script>

<style lang="css" scoped>
div {
  width: 30vw;
  height: 10vw;
  background-color: oklch(71.2% 0.194 13.428);
  font-size: 3rem;
  align-content: center;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  text-transform: uppercase;
  color: var(--color-grey-4);
  border-radius: 5px;
  animation-name: falling;
  animation-duration: 3s;
  position: relative;
}

@media only screen and (max-width: 768px) {
  div {
    width: 40vw;
    height: 30vw;
  }
}

span {
  margin-left: 1rem;
}

@keyframes falling {
  from {
    transform: translateY(-10rem);
  }
  to {
    transform: translate(0);
  }
}
</style>
